import AutoMitigateButton from "./AutoMitigateButton";

export default AutoMitigateButton;
